// GAVION rep stats: a rep's detail page (/rapports/vendeurs/:id), opened from the Leaderboard.
export const repStatsEn = {
  title: "%{name}'s stats",
  title_fallback: "Rep stats",
  back: "Back to the leaderboard",
  open_rep: "See %{name}'s stats",
  forbidden: "Only admins can see the conversation details of another rep.",
  not_found: "This rep cannot be found.",
  error: "Could not load the stats.",
  na: "n/a",
  period: {
    label: "Period",
    today: "Today",
    week: "This week",
    month: "This month",
    last30: "Last 30 days",
    custom: "Custom",
    from: "From",
    to: "To",
    apply: "Apply",
    range: "From %{from} to %{to}",
    previous: "Compared with the previous period: %{from} to %{to}.",
  },
  kpis: {
    title: "Key figures",
    dials: "Calls",
    conversations: "Conversations",
    conversation_rate: "Conversation rate",
    demos: "Demos booked",
    demo_rate: "Demo / conversation rate",
    deals_won: "Deals won",
    revenue_won: "Revenue won",
    close_rate: "Close rate",
    session_time: "Session time",
    dials_per_hour: "Calls per session hour",
    attempts: "Average attempts before 1st conversation",
    callbacks: "Callbacks kept",
    callbacks_detail: "%{kept} of %{due}",
    vs_previous: "%{delta} vs previous period",
    no_change: "Flat vs previous period",
    team_avg: "Team average: %{value}",
    team_none: "No team average",
    how: "How it is calculated: %{label}",
    help: {
      dials:
        "The rep's outbound calls in the period, except « Skip ». Same definition as the Leaderboard.",
      conversations:
        "Calls where a person answered: Talked – call back, Demo booked, Brochure sent or Not interested. Same definition as the Leaderboard.",
      conversation_rate: "Conversations ÷ calls.",
      demos: "Calls with the « Demo booked » outcome.",
      demo_rate: "Demos booked ÷ conversations.",
      deals_won:
        "Non-archived deals moved to « Won » in the period (sale date).",
      revenue_won: "Sum of the amounts of the deals won in the period.",
      close_rate:
        "Demos booked in the period whose deal (created by the demo) is now won ÷ demos booked.",
      session_time:
        "Length of the calling sessions in the period (an open session counts until now).",
      dials_per_hour: "Calls ÷ session hours. n/a under one minute of session.",
      attempts:
        "For each lead whose very first conversation (any rep) was made by this rep in the period: number of calls on that lead up to and including that conversation. Average per lead.",
      callbacks:
        "Promised callbacks (« Talked – call back ») due in the period: kept when the rep called the lead within ± %{minutes} min of the due time. A callback counts once its window is over.",
    },
  },
  funnel: {
    title: "Funnel",
    detail: "%{rate} of the previous step",
    team: "Team average: %{value}",
  },
  trend: {
    title: "Daily trend",
    aria: "Calls, conversations and demos per day from %{from} to %{to}",
    table: "See the numbers per day",
    day: "Day",
    dials: "Calls",
    conversations: "Conversations",
    demos: "Demos",
  },
  outcomes: {
    title: "Call outcomes",
    value: "%{count} (%{share})",
  },
  reasons: {
    title: "« Not interested » reasons",
    unknown: "Not given",
    empty: "No « Not interested » in the period.",
  },
  best_hours: {
    title: "Best hours",
    hint: "Lead's local time, last %{days} days (independent of the chosen period, to have enough calls).",
    empty: "Not enough calls yet for an hours map.",
  },
  segments: {
    trade: "By trade",
    region: "By region",
    none: "Not set",
    key_trade: "Trade",
    key_region: "Region",
    dials: "Calls",
    conversation_rate: "Conversation rate",
    demo_rate: "Demo / conversation rate",
    empty: "No calls in the period.",
  },
  conversations: {
    title: "Conversations",
    filter: "Outcome",
    all: "All outcomes",
    count: "%{smart_count} conversation |||| %{smart_count} conversations",
    date: "Date",
    lead: "Lead",
    outcome: "Outcome",
    note: "Note",
    follow_up: "Follow-up",
    meeting: "Meeting",
    empty: "No conversations in the period.",
    no_note: "—",
    more: "Read more",
    less: "Show less",
    callback: "Callback on %{date}",
    demo: "Demo on %{date}",
    deal_stage: "Deal: %{stage}",
    reason: "Reason: %{reason}",
    meeting_link: "Granola note",
    meeting_page: "See the meeting",
    page: "Page %{page} of %{pages}",
    previous: "Previous",
    next: "Next",
    pagination: "Conversations pagination",
  },
  demo_seed: {
    button: "Load sample data (demo)",
    loading: "Loading…",
    hint: "Demo mode: adds 3 sample reps with their calls, sessions, deals and costs to explore the stats.",
  },
};
